/** Product branding — single source for user-facing copy and default URLs. */
export const PRODUCT_NAME = "Tessera"
export const APP_ORIGIN = "https://platform.tesseratrades.com"
export const MARKETING_SITE_URL = "https://tesseratrades.com"
export const HELP_CENTRE_URL = "https://help.tesseratrades.com"
